import React from "react";
import { Platform, StyleSheet, View } from "react-native";
import { LinearGradient } from "expo-linear-gradient";
import { backgroundColor } from "../../constants/Constants";

const WebBackgroundDecor = () => {
  if (Platform.OS !== "web") return null;

  return (
    <div
      aria-hidden="true"
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        overflow: "hidden",
        pointerEvents: "none",
        zIndex: 1,
      }}>
      <div className="app-bg-dots" />
    </div>
  );
};

export default function AppScreenBackground({ children, style, contentStyle }) {
  return (
    <View style={[styles.root, style]}>
      <LinearGradient
        colors={backgroundColor()}
        start={{ x: 0, y: 0 }}
        end={{ x: 1, y: 1 }}
        style={styles.gradient}
      />
      <WebBackgroundDecor />
      <View style={[styles.content, contentStyle]}>{children}</View>
    </View>
  );
}

const styles = StyleSheet.create({
  root: {
    flex: 1,
    position: "relative",
    overflow: "hidden",
  },
  gradient: {
    ...StyleSheet.absoluteFillObject,
    zIndex: 0,
  },
  content: {
    flex: 1,
    zIndex: 2,
    position: "relative",
    backgroundColor: "transparent",
  },
});
